import { Directive } from "vue";

const handlers = new WeakMap<HTMLTextAreaElement, () => void>();
const minimumHeights = new WeakMap<HTMLTextAreaElement, number>();

function resizeTextarea(element: HTMLTextAreaElement) {
  const styles = window.getComputedStyle(element);
  const borderHeight =
    Number.parseFloat(styles.borderTopWidth) +
    Number.parseFloat(styles.borderBottomWidth);

  element.style.height = "auto";
  element.style.height = `${Math.max(
    element.scrollHeight + borderHeight,
    minimumHeights.get(element) || 0
  )}px`;
}

export const autoResize: Directive<HTMLTextAreaElement> = {
  mounted(element) {
    element.style.boxSizing = "border-box";
    element.style.overflowY = "hidden";
    element.style.resize = "none";
    minimumHeights.set(element, element.offsetHeight);

    const resize = () => resizeTextarea(element);
    handlers.set(element, resize);
    element.addEventListener("input", resize);
    window.addEventListener("resize", resize);
    resize();
  },
  updated(element) {
    resizeTextarea(element);
  },
  unmounted(element) {
    const resize = handlers.get(element);
    if (resize) {
      element.removeEventListener("input", resize);
      window.removeEventListener("resize", resize);
    }
    handlers.delete(element);
    minimumHeights.delete(element);
  },
};
